import { MerchantModel } from '@/models/MerchantModel';
import { LocationPoint, ShopFilter } from '@/types';
import { SearchMethod } from '@/enums/search-method';
import { CurbsideModel } from '@/models/CurbsideModel';

export interface RootState {
  merchantList: MerchantModel[];
  location: LocationPoint | null;
  searchMethod: SearchMethod;
  shopFilter: ShopFilter & {
    searchName: string | null;
  };
  curbsideData: CurbsideModel | null;
}

const state: RootState = {
  merchantList: [],
  location: null,
  searchMethod: SearchMethod.SearchByLocation,
  shopFilter: {
    currentlyOpen: false,
    curbsidePickup: false,
    searchName: null,
  },
  curbsideData: null,
};

export default state;
